export default "__VITE_ASSET__DxcrwoVf__"